module.exports = __webpack_public_path__ + "fb40c64e31973c73ebb96012635d09fd.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/message-16-ok.png
// module id = 211
// module chunks = 0